/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum EnrollmentsReportColumn {
  fullName = 'fullName',
  comments = 'comments',
  company = 'company',
  state = 'state',
  email = 'email',
  age = 'age',
  dateOfBirth = 'dateOfBirth',
  employeeClass = 'employeeClass',
  zorroId = 'zorroId',
  idFromEmployer = 'idFromEmployer',
  enrollmentStatus = 'enrollmentStatus',
  benefitStatus = 'benefitStatus',
  timeInStatus = 'timeInStatus',
  carrier = 'carrier',
  planName = 'planName',
  enrollmentStartDate = 'enrollmentStartDate',
  isQleEnrollment = 'isQleEnrollment',
  familyUnit = 'familyUnit',
  policyType = 'policyType',
  electionSubmittedDate = 'electionSubmittedDate',
  enrollmentConfirmedDate = 'enrollmentConfirmedDate',
  applicationSentDate = 'applicationSentDate',
  paymentsProvider = 'paymentsProvider',
  initialPaymentStatus = 'initialPaymentStatus',
  autoPayStatus = 'autoPayStatus',
  autoPayDate = 'autoPayDate',
  isAutoPayDateEndOfMonth = 'isAutoPayDateEndOfMonth',
  aorCancellationStatus = 'aorCancellationStatus',
  carrierRequestStatus = 'carrierRequestStatus',
  enrollmentTeam = 'enrollmentTeam',
  enrollmentTeamId = 'enrollmentTeamId',
  enrollmentTeamName = 'enrollmentTeamName',
  assignee = 'assignee',
  enrollmentAgentEmail = 'enrollmentAgentEmail',
  enrollmentTags = 'enrollmentTags',
  premium = 'premium',
  planMarket = 'planMarket',
  planId = 'planId',
  metalLevel = 'metalLevel',
  employerContribution = 'employerContribution',
  employeeContribution = 'employeeContribution',
  allowance = 'allowance',
  coverageChange = 'coverageChange',
  selfEnroll = 'selfEnroll',
  applicationSentByName = 'applicationSentByName',
  confirmedByName = 'confirmedByName',
  onboardingFrom = 'onboardingFrom',
  onboardingUntil = 'onboardingUntil',
  employeeTerminationDate = 'employeeTerminationDate',
  enrollmentUrl = 'enrollmentUrl',
  eligibleFrom = 'eligibleFrom',
  eligibleUntil = 'eligibleUntil',
  enrollmentEndDate = 'enrollmentEndDate',
}
